<template>
  <div class="position-relative">
    <ApprovalConfirmation v-if="ApprovalListchange.length != 0 &&
      ApprovalListchange.some(item => item['IsApproved'] == 0) && Number(QueryStringValue?.IsApproval) !== 1
    " :approvaldata="ApprovalListchange" :approvaldetails="approvaldetails" @triggerDetails="getApprovaldata()"
      @Approve="Approve" :SuccessfullPopUp="SuccessfullPopUp" />
    <ApprovalStatus v-if="ApprovalList.length != 0 && Number(QueryStringValue?.IsApproval) !== 1"
      :ApprovalgetList="ApprovalList" :approvaldetails="approvaldetails" />
    <div>
      <div class="overall-bg pb-0">
        <b-container class="pb-0">
          <b-row>
            <b-col>
              <BacktoPage :goback="$router.back" v-if="Number(QueryStringValue?.IsApproval) !== 1"></BacktoPage>
              <b-row class="field pt-4 mb-0">
                <b-col lg="2" class="field">
                  <label class="mb-0">{{ $t("PurchaseRequest.Code") }}</label>
                  <p class="">{{ details.DocNo }}</p>
                </b-col>
                <b-col lg="2" class="field">
                  <label class=" mb-0">{{ $t("PurchaseRequest.Date") }}</label>
                  <p class="">{{ details.DocDate }}</p>
                </b-col>
                <b-col lg="2" class="field">
                  <label class=" mb-0">{{ $t("PurchaseRequest.RequestedBy") }}</label>
                  <p class="">{{ details.CreatedByName }}</p>
                </b-col>
                <b-col lg="2" class="field">
                  <label class=" mb-0">{{ $t("PurchaseRequest.RequestedStore") }}</label>
                  <p class="">{{ details.ToStoreName }}</p>
                </b-col>
                <b-col lg="4">
                  <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2 float-end"
                    @click="Print" />
                </b-col>
              </b-row>

            </b-col>

          </b-row>
          <div class='field' v-if="uploadedTableList.length != 0">
            <label class=" mb-0">{{ $t("PurchaseRequest.QuotationFile") }}</label>
          </div>
          <b-row>
            <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
              <div class="fileuploadcard my-2" :title="item.fileName">
                <div>
                  <p class="filenametxt">{{ item.fileName }}</p>
                  <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                    view </div>
                </div>
              </div>

            </b-col>
          </b-row>
          <b-row>
            <b-col lg="10" md="8" sm="12" cols="12">
              <div class="field mt-3">
                <CustomTextarea v-model="details.Remarks" :requiredIcon="false" placeholder=" " name="Remarks"
                  id="Remarks" :label="$t('item.Remarks')" :rules="{ required: false }" :disabled="true" />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <section class="details_collapse">
        <b-container fluid>
          <b-row>
            <b-col>
              <p v-b-toggle.collapse-details variant="primary" class="float-end mb-3 pe-3 me-5">
                <span class="when-open">Collapse Flow Chart</span><span class="when-closed">Expand Flow Chart</span>
              </p>
            </b-col>
          </b-row>
          <b-collapse id="collapse-details" class="mt-2">
            <BlackCard v-model="data_insert" :loading="loading" />
          </b-collapse>
        </b-container>
      </section>

      <div class="overall-bg">
        <b-container class="form-white-bg transactiontabs">
          <!-- <p class="common-heading1 mb-3">Items Details</p> -->
          <TabView class="tabview-custom" ref="tabview4" :scrollable="true">
            <TabPanel>
              <template #header>
                <i class="pi pi-align-left pe-3" :class="details.ItemCount > 0 ? '' : 'withoutbadge'"></i>
                <span :class="details.ItemCount > 0 ? '' : 'withoutbadge'">Items
                  <Badge severity="warning" v-if="details.ItemCount > 0" :value="details.ItemCount"></Badge>
                </span>
              </template>
              <div>
                <PRItemTblview @TableDetails="TableDetails" :QueryValue="QueryStringValue"></PRItemTblview>
              </div>
            </TabPanel>
            <TabPanel>
              <template #header>
                <i class="pi pi-align-left pe-3" :class="ObjVal1.arraylenght > 0 ? '' : 'withoutbadge'"></i>
                <span :class="ObjVal1.arraylenght > 0 ? '' : 'withoutbadge'">PO
                  <Badge :value="ObjVal1.arraylenght" severity="warning" v-if="ObjVal1.arraylenght > 0"></Badge>
                </span>
              </template>
              <div>
                <POTableview v-model="ObjVal1" :QueryValue="QueryStringValue" />
              </div>
            </TabPanel>
            <TabPanel>
              <template #header>
                <i class="pi pi-align-left pe-3" :class="ObjVal5.arraylenght > 0 ? '' : 'withoutbadge'"></i>
                <span :class="ObjVal5.arraylenght > 0 ? '' : 'withoutbadge'">GRN
                  <Badge :value="ObjVal5.arraylenght" severity="warning" v-if="ObjVal5.arraylenght > 0"></Badge>
                </span>
              </template>
              <div>
                <GrnTable v-model="ObjVal5" :QueryValue="QueryStringValue"></GrnTable>
              </div>
            </TabPanel>
          </TabView>
        </b-container>
      </div>
    </div>
  </div>

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/NormalTable.vue";
import PRItemTblview from "../../../../../modules/Inventory/pages/Transaction/PurchaseRequest/PRItemTable.vue";
import POTableview from "../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import GrnTable from "../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import GrnReturnTableview from "../../../../../modules/Inventory/pages/Transaction/StockOut/grnreturn/GrnReturnTableview.vue";
import BlackCard from "../../../../../components/Chart/PIFlowChart.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import commonService from "../../../Service/WithoutStockAffectService";
import ApprovalConfirmation from "../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../components/FormComponents/ApprovalStatus.vue";
import PoApprovalService from "../../../Service/PoApprovalService";
import moment from "moment";
import CustomTextarea from "../../../../../components/FormComponents/TextArea.vue";
import StockWOFileUploadServices from "../../../../../modules/Inventory/Service/StockWOFileUploadService";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    CustomTextarea,
    BacktoPage,
    Tableview,
    PRItemTblview,
    POTableview,
    GrnTable,
    BlackCard,
    Loader,
    ApprovalConfirmation,
    ApprovalStatus,
    CrystalReportPrintPopUp

  },

  props: {
    Operations: {
      type: Object,
      default: () => ({}),
    },
    ApprovalObj: {
      type: Object,
      default: () => ({}),
    },
  },


  setup(props, { emit }) {

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    const route = useRoute();
    const routers = useRouter();
    let items = ref([]);
    let loading = ref(false);
    const menu = ref();

    let ApprovalList = ref([]);
    let ApprovalListchange = ref([]);

    let data_insert = ref({
      poarraylenght: 0,
      Qarraylenght: 0,
      grnarraylenght: 0,
    });
    let ObjVal1 = ref({
      arraylenght: 0,
    });

    let ObjVal5 = ref({
      arraylenght: 0,
    });

    watch(
      () => ObjVal1.value,
      (newVal) => {
        debugger;
        loading.value = true;
        data_insert.value.Qarraylenght = Number(newVal.arraylenght);
        loading.value = false;
      }
    );

    let QueryStringValue = ref(route.query);

    watch(
      () => [props.Operations, props.ApprovalObj],
      ([newOperations, newApprovalObj]) => {
        debugger;
        if (newOperations.PRId) {
          QueryStringValue.value = newOperations;
        }

        if (newApprovalObj.Status) {
          UpdateApprovalStatus(newApprovalObj.Status);
        }
      },
      { immediate: true, deep: true }
    );


    const action = ref([
      {
        items: [
          {
            label: "Close the request",
          },
        ],
      },
    ]);

    const toggle = (event: MouseEvent) => {
      menu.value.toggle(event);
    };

    const headers = [

      {
        header: "Category",
        field: "ItemCategory1",
        class: "smallwidth coumnfreezeleft1"
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth coumnfreezeleft2"
      },
      {
        header: "Name",
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth coumnfreezeleft3",
      },
      {
        header: "Brand / Model /Size",
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: "UOM",
        field: "UOMName",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Avl Qty",
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "Reorder Level",
        field: "ReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "PackSize Name",
        field: "PackSizename1",
        class: "smallwidth"
      },
      {
        header: "PackSize Qty",
        field: "PackSizeQty",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "Unit Rate",
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Req Qty",
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Rate",
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },

    ];

    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    let details: any = ref({
      SupplierId: 0,
      Price: "",
      PRdate: "",
      Paymentterms: "",
      DeliveryTerms: "",
      DocNo: "",
      RefNo: "",
      SupplierName: "",
      Address: "",
      suppliername: "",
      GST: "",
      DocType: "",
      StoreId: 0,
      PRstatus: 0,
      CreatedAt: "",
      ItemCount: 0,
      EntityId: 0,
      DocDate: "",
      CreatedByName: "",
      QuotationFileName: "",
      Remarks: ""
    });

    let approvaldetails: any = ref({
      HeaderName: "PR",
      ContentName: "Purchase Request",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });

    onMounted(() => {
      PRDetails();
      if (QueryStringValue.value.IsApproval != "1") {
        getApprovaldata();
      }
    });

    async function PRDetails() {
      debugger;
      const response = await commonService.GetByStockWOTransId(
        QueryStringValue.value.PRId
      );
      debugger;
      let data = response["result"][0];
      console.log(data);

      details.value.Price = data.grossamount;
      details.value.SupplierId = data.SupplierId;
      details.value.PRdate = data.DocDate;
      details.value.DocNo = data.DocNo;
      details.value.RefNo = data.RefNo;
      details.value.CreatedAt = data.CreatedAt;

      details.value.DocType = data.DocType;
      details.value.StoreId = data.StoreId;
      details.value.PRstatus = data.Status;
      details.value.EntityId = data.EntityId

      details.value.DocDate = data.DocDateHR;
      details.value.CreatedByName = data.CreatedByName;
      details.value.ToStoreName = data.ToStoreName;

      approvaldetails.value.ApprovalCode = data.DocNo;
      approvaldetails.value.ApprovalDate = data.DocDateHR;
      approvaldetails.value.CreatedAt = data.CreatedAt;
      approvaldetails.value.ApprovalPrice = data.grossamount;


      details.value.QuotationFileName = data["QuotationFileName"]
      details.value.Remarks = data["Remarks"]

      const FileUploadresult = await StockWOFileUploadServices.getStockWOFileById(
        QueryStringValue.value.PRId
      );
      if (FileUploadresult['result'].length > 0) {
        for (let i = 0; i < FileUploadresult['result'].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
            (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
            (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
            (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
            (Fileobj["Id"] = FileUploadresult['result'][i].Id),
            uploadedTableList.value.push(Fileobj)
        }
      }
      else {
        uploadedTableList.value = [];
      }
    }

    function TableDetails(data) {
      debugger;
      details.value.ItemCount = data.arraylenght;
    }

    async function getApprovaldata() {
      debugger;
      try {
        let response = await PoApprovalService.GetPOApprovalList(
          QueryStringValue.value.PRId,
          usersData.OrganizationId,
          QueryStringValue.value.BranchId,
          QueryStringValue.value.EntityId
        );

        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"].filter(
          (item) => item.DepRoleID == rolesData.DeptRoleMapId
        );
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    }

    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });

    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: usersData.UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0
    });

    async function Approve(Values) {
      debugger;
      try {


        let rowToAssign = null;

        for (let i = 0; i < ApprovalListchange.value.length; i++) {
          if (ApprovalListchange.value[i]["IsApproved"] === 0) {
            rowToAssign = ApprovalListchange.value[i];
            break; // Exit the loop once the first matching row is found
          }
        }

        if (rowToAssign) {
          isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
          isForm.value.Id = rowToAssign["ID"];
          isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];

          isForm.value.IsApproved = Values.Approvalstatus;
          isForm.value.Remarks = Values.Remarks;
          isForm.value.EntityId = details.value.EntityId;
        }

        let response;
        if (isForm.value.IsApproved == 1) {
          response = await PoApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1 || response["result"] == 2) {
              UpdateApprovalStatus(response["result"]);
            }
            SuccessfullPopUp.value.accept = true;

          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await PoApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            UpdateApprovalStatus(isForm.value.IsApproved);
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function UpdateApprovalStatus(status) {
      debugger;
      try {
        const response = await commonService.UpdateApprovalStatus(
          QueryStringValue.value.PRId,
          status
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
        }
      } catch (error) {
        console.log(error);
      }
    }

    let uploadedTableList: any = ref([])
    function fileviewer(data) {
      debugger
      const newTabUrl = data;
      window.open(newTabUrl, '_blank');
    }

    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 41,
      HeaderTitle: "Purchase Request",
      ModuleId: 3,
    });

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = QueryStringValue.value.PRId;
      ParameterValues.value.BranchId = QueryStringValue.value.BranchId;
      ParameterValues.value.HospitalId = usersData.OrganizationId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    return {
      fileviewer,
      uploadedTableList,
      action,
      toggle,
      menu,
      globalFilterFields,
      items,
      headers,
      filters,
      loading,
      details,
      approvaldetails,
      TableDetails,
      getApprovaldata,
      UpdateApprovalStatus,
      ApprovalList,
      ApprovalListchange,
      Approve,
      SuccessfullPopUp,
      ObjVal1,
      ObjVal5,
      data_insert,
      QueryStringValue,
      Print,
      hidepopup,
      ParameterValues,
      PrintType,
      CrystalReportPopup
    };
  },
});
</script>

<style lang="scss" scoped>
.tab-icon {
  width: 30px;
}

.blackbg {
  background-color: #303030;
  height: 150px;
}

.withoutbadge {
  padding-top: 5px;
  padding-bottom: 2px;
}
</style>
